import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import LayerUpload from "../components/LayerUpload";


const { Formik } = formik;

class DialogUploadLayer extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

//	handleSubmit(data){
//
//		
//		this.updateStatus({sent:false, success:false, message:'Changing project state...'});
//		//saveguard for testing
//
//		var data = {...data,
//			projectId: this.props.projectid,
//			username: this.props.user.userDetails
//		}
//	
//		
//		//console.log(setMainScenario);
//		atlasApi.projectState(this.props.projectid, data).then((response)=>{
//			if(response.success){
//				this.updateStatus({sent:true, success:true, message:'The project state was changed'});
//				setTimeout(()=>this.handleClose(), 2000);
//			}
//			else
//				this.updateStatus({sent:true, success:false, message:'Error changing state'});
//			
//			
//			
//		}).catch((e)=>{
//			this.updateStatus({sent:true, success:false, message:'Error changing state'});
//		});
//		//this.updateStatus({sent:false, success:false, message:'Saving...'});
//		
//	};
	handleUploadComplete(data){
		var self = this;
		
		if(data.id || Array.isArray(data) || data.features){
			this.updateStatus({sent:true, success:true, message:'Your data was uploaded'});
			if(this.props.onUpload){
				this.props.onUpload(data);
			}
			if(this.props.setup?.onUpload){
				this.props.setup.onUpload(data);
			}
			setTimeout(()=>{
				self.handleClose();
			}, 2000);
		}
		else{
			this.updateStatus({sent:true, success:false, message:'Error uploading data'});
		}
		
	}


	render() {
		return (
			<Modal className={"upload-modal"} show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header>
					<Modal.Title>{this.props.title ? this.props.title : 'Upload data'}</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.projectState} initialValues={{}}>	
					{({ handleSubmit, handleChange, values, touched, errors }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
									
										<Row className="mb-3 p-3">
											<LayerUpload type={this.props.type ? this.props.type : 'uploadFile'} onUpload={(layer)=>{this.handleUploadComplete(layer);}} user={this.props.user} country={this.props.country} />
										</Row>
									</Modal.Body>
									

								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogUploadLayer;